/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText, FormSilverpopRequiredFields, FormTypes } from '@powdr/constants';

export const EmailSignupPopupForm = ({
  reCaptchaPublicKey,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
  trackingTitle = null,
}) => {
  const captchaRef = useRef();

  return (
    <form
      id="boreal-email-signup"
      title={trackingTitle}
      onSubmit={(e) => processForm(
        e,
        null,
        null,
        captchaRef,
        FormTypes.SILVERPOP,
      )}
    >

      <h2>Sign Up For Email Alerts</h2>

      <input name="CONTACT_LIST_ID" type="hidden" value="13905290" />

      <input
        name="First Name"
        id="control_COLUMN3"
        className="form-control"
        type="text"
        placeholder="First Name *"
        required
      />

      <input
        name="Last Name"
        id="control_COLUMN4"
        className="form-control"
        type="text"
        required
        placeholder="Last Name *"
      />

      <input
        className="form-control"
        type="text"
        name={FormSilverpopRequiredFields.EMAIL}
        id="control_EMAIL"
        label="Email Address"
        required
        placeholder="Email Address"
      />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={reCaptchaPublicKey}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button
        type="submit"
        value="Submit"
        disabled={!isUserVerified}
      >
        {buttonText || ButtonText.SUBMIT}
      </button>
    </form>
  );
};

EmailSignupPopupForm.propTypes = {
  reCaptchaPublicKey: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  trackingTitle: PropTypes.string,
};
